export const carriagesInfo = {
  chernivtsi_wroclaw: {
    startDate: new Date(2018, 7, 3),
    phones: [
      ['380936057475', '48884180038'],
      ['380999501065', '48889965820'],
      ['380999501615', '48886924527'],
      ['380999501160', '48889965843'],
      ['380999506660', '48880992710'],
    ]
  },
  wroclaw_chernivtsi: {
    startDate: new Date(2018, 7, 5),
    phones: [
      ['380936057475', '48884180038'],
      ['380999501065', '48889965820'],
      ['380999501615', '48886924527'],
      ['380999501160', '48889965843'],
      ['380999506660', '48880992710'],
    ]
  },
  chernivtsi_bydgoszcz: {
    startDate: new Date(2018, 7, 3),
    phones: [
      ['380997664612', '48788518174'],
      ['380997664616', '48788518173'],
      ['380997664617', '48788518170'],
      ['380997664716', '48788518168'],
      ['380997664714', '48788518166'],
      ['380997664718', '48788518165'],
    ]
  },
  bydgoszcz_chernivtsi: {
    startDate: new Date(2018, 7, 5),
    phones: [
      ['380997664612', '48788518174'],
      ['380997664616', '48788518173'],
      ['380997664617', '48788518170'],
      ['380997664716', '48788518168'],
      ['380997664714', '48788518166'],
      ['380997664718', '48788518165'],
    ]
  },
  chernivtsi_szczecin: {
    startDate: new Date(2018, 7, 4),
    phones: [
      ['380501600909', '48880872940'],
      ['380501800909', '48880872955'],
      ['380501900909', '48880872959'],
      ['380506100909', '48880873144'],
      ['380509900909', '48880873400'],
      ['380506700909', '48880873417'],
    ]
  },
  szczecin_chernivtsi: {
    startDate: new Date(2018, 7, 6),
    phones: [
      ['380501600909', '48880872940'],
      ['380501800909', '48880872955'],
      ['380501900909', '48880872959'],
      ['380506100909', '48880873144'],
      ['380509900909', '48880873400'],
      ['380506700909', '48880873417'],
    ]
  },
  chernivtsi_zielonaGora: {
    startDate: new Date(2018, 7, 1),
    phones: [
      ['380668139991', '48886499387'],
      ['380663649992', '48578133652'],
      ['380661879993', '48888716020'],
      ['380955819994', '48578133635'],
      ['380950829995', '48578133642'],
      ['380995344996', '48578133650'],
    ]
  },
  zielonaGora_chernivtsi: {
    startDate: new Date(2018, 7, 3),
    phones: [
      ['380668139991', '48886499387'],
      ['380663649992', '48578133652'],
      ['380661879993', '48888716020'],
      ['380955819994', '48578133635'],
      ['380950829995', '48578133642'],
      ['380995344996', '48578133650'],
    ]
  },
  chernivtsi_plzen: {
    phones: [
      ['380977707030', '48---------', '420776856655'],
      ['380968455428', '48788382225', '420775335428'],
      ['380506086901', '48885331719', '420774514620'],
      ['380507291312', '48602357705', '420776540325'],
      ['380962056503', '48884175892', '420775387553'],
      ['380668579515', '48539829217', '420608349886'],
    ]
  },
  plzen_chernivtsi: {
    phones: [
      ['380506086901', '48885331719', '420774514620'],
      ['380668579515', '48539829217', '420608349886'],
      ['380977707030', '48---------', '420776856655'],
      ['380968455428', '48788382225', '420775335428'],
      ['380507291312', '48602357705', '420776540325'],
      ['380962056503', '48884175892', '420775387553'],
    ]
  },
  kyiv_prague: {
    phones: [
      ['380962209952', '48574346249', '420777537246'],
    ]
  },
  prague_kyiv: {
    phones: [
      ['380962209952', '48574346249', '420777537246'],
    ]
  },
  cherkasy_plzen: {
    phones: [
      ['380684977245', '48737977245', '420777537246'],
      ['380684977245', '48693994239', '420608105215'],
    ]
  },
  plzen_cherkasy: {
    phones: [
      ['380684977245', '48693994239', '420608105215'],
      ['380684977245', '48737977245', '420777537246'],
    ]
  },
  salerno_zaporizhia: {
    phones: [
      ['393391594831', '30961404055']
    ]
  },
  zaporizhia_salerno: {
    phones: [
      ['393391594831', '30961404055']
    ]
  }
}



// WEBPACK FOOTER //
// ./src/constants/objects.js